<template>
    <div class="template-wrapper">
		<h2 class="page-title">{{ $t('paymentRecords') }}</h2>
		<el-divider></el-divider>
    <template v-if="exportcsv === '1'">
        <!--
      <export-excel
			:data="tableDataExcel"
			:fields = "tableDataExcelFields"
			:name="$t('paymentRecords')+'.xls'"
			class="el-button el-button--default">
			{{ $t('exportPaymentRecords') }}
		</export-excel>-->
        <el-button @click="exporttocsv($t('paymentRecords'))">{{ $t("exportPaymentRecords") }}</el-button>
    </template>

    <template v-if="payment_read === '1'">
      <br />
      <br />
      <!--
      <el-form ref="storeform" :model="storeform">
        <el-form-item :label="$t('selectStore')">
          <template>
            <div class="" style="display: flex">
              <el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
                <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                <el-option v-for="item in storelist" :label="item.storeid+' ('+item.name+')'" :value="item.storeid"></el-option>
              </el-select>
            </div>
          </template>
        </el-form-item>
      </el-form>
      -->
      <el-collapse>
        <el-collapse-item :title="$t('searchByConditions')" name="1">
          <el-form ref="storeform" :model="storeform">
            <el-form-item :label="$t('selectStore')">
              <template>
                <div class="" style="display: flex">
                  <el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
                    <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                    <el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
                      :value="item.storeid"></el-option>
                  </el-select>
                </div>
              </template>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 20px;">
            {{ $t("searchByDate") }}
            <el-date-picker v-model="starttime" type="date" :placeholder="$t('selectDate')">
            </el-date-picker> {{ $t("to") }}
            <el-date-picker v-model="endtime" type="date" :placeholder="$t('selectDate')">
            </el-date-picker>
          </div>
          <div>
            <el-form ref="typeform" :model="typeform">
                <el-form-item :label="$t('type')">
                    <div style="display: flex">
                        <el-select v-model="typeform.type" placeholder="">
                            <el-option :label="$t('all')" value=""></el-option>
                            <el-option v-for="option in typeOptions" :label="$t(option.label)"
                                :value="option.value"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-form ref="paymentform" :model="paymentform">
                <el-form-item :label="$t('paymentMethod')">
                    <div style="display: flex">
                        <el-select v-model="paymentform.type" placeholder="">
                            <el-option :label="$t('all')" value=""></el-option>
                            <el-option v-for="option in paymentOptions" :label="$t(option.label)"
                                :value="option.value"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
            </el-form>
        </div>
          <el-button @click="filter()">{{ $t('search') }}</el-button>
        </el-collapse-item>
      </el-collapse>
      <br />
    </template>
    
    <template v-if="payment_read === '1'">
		<el-table :data="tableData" stripe style="width: 100%" @sort-change="sortChange">
      <el-table-column prop="paymenttime" :label="$t('time')" sortable="custom">
		<template slot-scope="scope">
			<div>{{scope.row.paymenttime}}</div>
		</template>
      </el-table-column>
      <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
			</el-table-column>
	  <el-table-column prop="orderid" :label="$t('orderid')" sortable="custom">
        <template slot-scope="scope">
            <div>{{ scope.row.orderid }}</div>
            <div v-if="scope.row.customordersn!== '' && scope.row.customordersn!== null">{{$t('customorderid')}}: {{ scope.row.customordersn }}</div>
            <div v-if="scope.row.paymenttype!== '' && scope.row.paymenttype!== null">{{$t('paymenttype')}}: {{ scope.row.paymenttype }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderid" :label="$t('type')" sortable="custom">
      <template slot-scope="scope">
          <div v-if="scope.row.orderid.startsWith('E') === true">WhatsApp EShop</div>
          <div v-if="scope.row.orderid.startsWith('P') === true">POS</div>
      </template>
      </el-table-column>
      <el-table-column prop="total_price" :label="$t('totalAmount')" sortable="custom">
      </el-table-column>
      <el-table-column prop="paymentmethod" :label="$t('paymentMethod')" sortable="custom">
        <template slot-scope="scope">
          <div v-if="scope.row.paymentmethod === 'fps' || scope.row.paymentmethod === 'FPS'">FPS</div>
          <div v-else>{{scope.row.paymentmethod}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="paymentid" :label="$t('paymentid')" sortable="custom">
      </el-table-column>


    </el-table>
    <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t('total') }} {{totalRecord}} {{ $t('items') }}</span>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev,pager,next"
          :total="totalRecord"
        ></el-pagination>
      </div>
    </template>
    <template v-if="payment_read === '0'">
        <span>{{ $t("NoPermissions") }}</span>
    </template>

    </div>
</template>




<script>
		import { formatDate } from '../../assets/date.js'
		import {getShopOrder, getShopOrder_2, getShopOrder_3, exportShopOrder_2, exportShopOrder_3, getStore} from '@/api'
export default {
    data() {
        return {
          payment_read: '0',
          payment_edit: '0',
          exportcsv: '0',
          show:false,
          currentPage: 1, // 当前页码
          pageSize: 15, // 每页显示的行数
          currentViewPage: 1, // 当前页码
          pageViewSize: 10, // 每页显示的行数
          dialogVisible: false,
          tableData: [
          
          ],
          tableDataExcel:[],
          tableDataExcelFields:{
            'payment time': 'paymenttime',
            'store id': 'storeid',
            'order id': 'orderid',
            'custom order id': 'customordersn',
            'payment type': 'paymenttype',
            'type': 'type',
            'name': 'name',
            'whatsapp': 'whatsapp',
            'products': 'products',
            'total amount':'totalprice',
            'payment method':'paymentmethod',
            'payment id':'paymentid'
          },
          viewData: {
            id: "",
            products: []
          },
          viewOrderTitle:"",
          qyid: '',
          storeid: '',
          storelist: [],
          storeform: {
            storeid: ''
          },
          typeOptions: [
				{ label: 'WhatsApp EShop', value: 'whatsapp_eshop' },
                { label: 'POS', value: 'pos' },
			],
            typeform: {
				type: ''
			},
            paymentOptions: [
				{ label: 'FPS', value: 'fps' },
                { label: 'otherPayment', value: 'other' },
			],
            paymentform: {
				type: ''
			},
            starttime: "",
            endtime: "",
        }
    },
	filters: {
	  formatDate: function (time) {
	          time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
	                   let date = new Date(time)
	                   return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
	    } 
	  },
	created() {
		var user = JSON.parse(window.localStorage.getItem("userinfo"));
		//console.log(user)
		//this.qyid = user.id 
    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		this.qyid = auser.qyid
        this.storeid = auser.storeid
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
		this.payment_read = auser.payment_read
		this.payment_edit = auser.payment_edit
		this.exportcsv = auser.exportcsv
		this.getlist(auser.storeid);
    this.getstorelist()
	},
    methods: {
		handleCurrentChange(val) {
			this.currentPage = val;
            this.getlist(this.storeform.storeid)
		},
    handleClose() {
      this.dialogVisible = false;
    },
    changeTableStoreid() {
				console.log('storeid:' + this.storeform.storeid)
				this.getlist(this.storeform.storeid)
			},
    getstorelist() {
				console.log('go taocan');
				var user = JSON.parse(window.localStorage.getItem('userinfo'))

				let fdata = {
					qyid: this.qyid,
                    storeid: this.storeid
				};
				getStore(fdata).then((res) => {
					if (res.code == 1) {
						console.log(res);
						this.storelist = res.data
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			},
            filter() {
                this.getlist(this.storeform.storeid)
            },
		getlist(storeid) {
		this.show=true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));



      let fdata = {
          //qyid: user.id,
          qyid: this.qyid,
          storeid: storeid,
          //action: "viewpayment"
          starttime: this.starttime,
          endtime: this.endtime,
          type: this.typeform.type,
          payment: this.paymentform.type,
          record_page: this.currentPage,
          record_limit: 15,
          action: "viewpaymentwaeshoppos3"
        };
        console.log("viewpaymentwaeshoppos33333333333333333")
        console.log(this.starttime + ", " + this.endtime)
        getShopOrder_3(fdata).then((res) => {
            if (res.code == 1) {
            console.log(res);
            this.tableData = res.data;
            this.totalRecord = res.total;
            } else {
            this.$message({
                type: "error",
                message: res.msg,
            });
            }
            this.show=false
        });
    },
    viewitem(id) {
        var user = JSON.parse(window.localStorage.getItem("userinfo"));
        let fdata = {
          //qyid: user.id,
          qyid: this.qyid,
          orderid: id,
          action: "view"
        };
        console.log('view: ' + id + " qyid: " + user.id)
        getShopOrder(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.viewOrderTitle = this.$t('viewOrders')+ ": " + id;
          this.viewData.id = id;
          this.viewData.products = res.data;
          console.log('res.data')
          console.log(res.data)
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }



        this.dialogVisible = true;
			});
    },
    exporttocsv(name) {
        let fdata = {
            //qyid: user.id,
            qyid: this.qyid,
            storeid: this.storeform.storeid,
            starttime: this.starttime,
            endtime: this.endtime,
            type: this.typeform.type,
            payment: this.paymentform.type,
            action: "viewpaymentwaeshoppos3"
        };
        exportShopOrder_3(fdata).then(res => {
				if (res.code == 1) {
					console.log('getUsersReporttttttttttttttttttt')
					console.log(res)
					//this.tableData = res.data
                    //this.totalRecord = res.total;
					this.tableDataExcel = res.dataExcel
					var csvContent= [
                    Object.keys(this.tableDataExcel[0]).join(","),
                        ...this.tableDataExcel.map(item => Object.values(item).join(","))
                    ]
                        .join("\n")
                        .replace(/(^\[)|(\]$)/gm, "");
                    var link = document.createElement('a');
                    // "\ufeff"是为了解决CSV中文乱码问题
                    var blob = new Blob(["\ufeff" +csvContent],{type: 'text/csv;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    link.href = url;
                    link.setAttribute('download', name + '.csv');
                    link.click();
                    document.body.removeChild(link);
                        } else {
                            console.log('eeeeeeeeeeeeeeeeeeeeee')
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

		},
    sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop,order));
    },
    compare (propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    }
    }
}
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}
.pendingList-wrapper {
}
.pagination {
width: 100%;
margin: 30px auto;
}
::v-deep .el-select {
width: 100%;
}
</style>